module.exports = __webpack_public_path__ + "media/country_flags/th-e3b08e71.png";